import { render, staticRenderFns } from "./MinusStockStatisticsList.vue?vue&type=template&id=93d17806&scoped=true"
import script from "./MinusStockStatisticsList.vue?vue&type=script&lang=js"
export * from "./MinusStockStatisticsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d17806",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93d17806')) {
      api.createRecord('93d17806', component.options)
    } else {
      api.reload('93d17806', component.options)
    }
    module.hot.accept("./MinusStockStatisticsList.vue?vue&type=template&id=93d17806&scoped=true", function () {
      api.rerender('93d17806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/minus-stock-statistics/MinusStockStatisticsList.vue"
export default component.exports